import React from "react";
import {Header} from "../../views/poi/partials";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core";
import styles from "../../views/district/styles";

const ShowIframe = ({classes, match}) => {
	const {iframe} =  match.params;

	return (
		<>
			<Header className={classes.header}/>
			<iframe src={`./data/medias/pdf/${iframe}.pdf`} title={iframe} style={{"overflow":"hidden","height":"100vh","width":"100%"}} height="100%" width="100%"/>
		</>
	)
}
ShowIframe.propTypes = {
	classes: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
};
export default withStyles(styles)(ShowIframe);

